import { render } from "./WalletCard.vue?vue&type=template&id=4765ff0f&scoped=true"
import script from "./WalletCard.vue?vue&type=script&lang=js"
export * from "./WalletCard.vue?vue&type=script&lang=js"

import "./WalletCard.vue?vue&type=style&index=0&id=4765ff0f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4765ff0f"]])

export default __exports__